import { render, staticRenderFns } from "./SubmitFooter.vue?vue&type=template&id=9e1f22b2&scoped=true&"
import script from "./SubmitFooter.vue?vue&type=script&lang=js&"
export * from "./SubmitFooter.vue?vue&type=script&lang=js&"
import style0 from "./SubmitFooter.vue?vue&type=style&index=0&id=9e1f22b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1f22b2",
  null
  
)

export default component.exports